import getTicketsAvailabilitySaga from './getTicketsAvailability';
import getTicketsSaga from './getTickets';

export const ticketSagas = [getTicketsSaga, getTicketsAvailabilitySaga];
